export default __webpack_public_path__ + "static/media/h_wdt_c_3.9727610f.mp3";